import React, { useMemo } from 'react';
import { OptionKey, SelectDropdown } from '@common-fe/common-fe';

import { ALL_OPTION_KEY } from '@/common/constants';
import { Option } from '@/common/types';
import { useSelectAllHandler } from '@/modules/core';

interface Props {
  options: Option[];
  testId?: string;
  values: OptionKey[];
  disabled?: boolean;
  onChangeValues: (value: OptionKey[]) => void;
}
const PlanSelector: React.FC<Props> = ({
  values,
  testId = 'plan_selector',
  onChangeValues,
  options,
  disabled,
}) => {
  const currentValues = useMemo(() => {
    if (!values.length && !disabled) {
      return [ALL_OPTION_KEY];
    }
    return values;
  }, [disabled, values]);
  const handleChangeValues = useSelectAllHandler(values, onChangeValues);

  return (
    <SelectDropdown
      testId={testId}
      ellipsisMode
      disabled={disabled}
      activeTitle
      singleMode={false}
      options={options}
      values={currentValues}
      onChangeValues={handleChangeValues}
      prefix="Plan name"
      id="plan_selector"
      name="plan_selector"
      allMode
    />
  );
};

export default PlanSelector;
